import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import ModularBlocks from '../components/ModularBlocks';

const IndexPage = () => {
  const { datoCmsHome } = useStaticQuery(graphql`
    query IndexPageQuery {
      datoCmsHome {
        seoMetaTags {
          ...GatsbyDatoCmsSeoMetaTags
        }
        title
        bannerHeading
        bannerText {
          value
        }
        bannerLink {
          text
          pageUrl {
            ...LinkFragment
          }
        }
        bannerImage {
          url
          alt
        }
        bannerPartnerBadges {
          url
          alt
        }
        bannerPlatforms {
          title
          badge {
            url
            alt
          }
          ...LinkFragment
        }
        modularBlocks {
          ...ContactFormModularBlockFragment
          ...ContentModularBlockFragment
          ...ExternalVideoModularBlockFragment
          ...FaqsModularBlockFragment
          ...FeaturedBlogPostsModularBlockFragment
          ...FeaturedCaseStudiesModularBlockFragment
          ...FeaturedLogosModularBlockFragment
          ...FeaturedReviewsModularBlockFragment
          ...FeaturedStatisticsModularBlockFragment
          ...ImageContentBlocksModularBlockV1Fragment
          ...ImageContentBlocksModularBlockV2Fragment
          ...ImageContentCardsModularBlockFragment
          ...ImageContentCardsModularBlockIllustrationFragment
          ...ImageContentModularBlockV1Fragment
          ...ImageContentModularBlockIllustrationFragment
          ...ImageContentModularBlockV2Fragment
          ...InternalVideoModularBlockFragment
          ...ServicesModularBlockFragment
        }
        ...LinkFragment
      }
    }
  `);

  const {
    seoMetaTags,
    title,
    bannerHeading,
    bannerText,
    bannerLink,
    bannerImage,
    bannerPartnerBadges,
    bannerPlatforms,
    modularBlocks,
  } = datoCmsHome;

  return (
    <Layout seo={seoMetaTags} page={datoCmsHome}>
      <HelmetDatoCms>
        <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "Organization",
            "url": "${process.env.GATSBY_SITE_URL}",
            "logo": "${process.env.GATSBY_SITE_URL + '/logo.svg'}"
          }`}
        </script>
      </HelmetDatoCms>
      <main>
        <Banner
          heading={bannerHeading || title}
          text={bannerText}
          link={bannerLink}
          image={bannerImage}
          partnerBadges={bannerPartnerBadges}
          platforms={bannerPlatforms}
        />
        <ModularBlocks items={modularBlocks} />
      </main>
    </Layout>
  );
};

export default IndexPage;
